import React from "react";
import { Link, useLocation } from 'react-router-dom';



const Navbar = () => {
  const { pathname } = useLocation();
    return(
        

    <nav className="navbar">

        
        <Link to="/" className="logo">Prec10us</Link> 

       <ul className="nav-links">
        <li>
          <Link to="/" 
          className={pathname === "/" ? 'active' : ''}
          >
            Home 
          </Link>
        </li>

        <li>
          <Link to="/about"
          className={pathname === "/about" ? 'active' : ''}
          >
            About 
          </Link>
        </li>

        <li>
          <Link to="/projects" 
          className={pathname === "/projects" ? 'active' : ''}
          >
            Projects 
          </Link>
        </li>

        <li>
          <Link to="/contact"
          className={pathname === "/contact" ? 'active' : ''}
          >
            Contact 
          </Link>
        </li>

        </ul>
    </nav>


    );
};

export default Navbar;